module.exports = __webpack_public_path__ + "img/7-1_07.f4f8cf8f.jpg";